module.exports = __webpack_public_path__ + "static/media/Localvore_horizontal_2c.2618adce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Localvore_horizontal_2c.png
// module id = 915
// module chunks = 4